import type { HelpTopic } from "@/lib/help-content";

export function HelpTopicGrid({ topics }: { topics: HelpTopic[] }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {topics.map((t) => {
        const Icon = t.icon;
        return (
          <article
            key={t.title}
            className="rounded-3xl border border-border bg-card p-5 shadow-soft"
          >
            <header className="mb-3 flex items-center gap-3">
              <div className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-gradient-hero text-primary-foreground">
                <Icon className="h-5 w-5" />
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-semibold leading-tight">{t.title}</h3>
                <p className="text-xs text-muted-foreground">{t.description}</p>
              </div>
            </header>
            <ul className="space-y-2 text-sm">
              {t.bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-2">
                  <span
                    aria-hidden="true"
                    className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary"
                  />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </article>
        );
      })}
    </div>
  );
}
